<!--
 * @Description: 新增下拉框选项
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-09 15:43:19
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-09 16:41:13
-->
<template>
    <el-dialog
    :title = "'新增' + title + '下拉选项'"
    :visible.sync="dialogVisible"
    append-to-body
    :close-on-click-modal='false'
    class="default-dialog"
    width="500px">
        <div>
            <el-input 
                v-model = "itemStr" 
                type = "textarea" 
                placeholder="请将选项用 “换行” 隔开" 
                :autosize="{minRows:6}"
            ></el-input>
            <div class = "center top15">
                <accBtn type = "2" text = "取消" size='mini' @click = "dialogVisible = false"></accBtn>
                <accBtn size='mini' @click = "handleAdd" :loading = "loading"></accBtn>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props:{
      title: String,
      loading: Boolean  
    },
    data() {
        return {
            dialogVisible: false,
            itemStr:""
        }
    },
    watch: {
        dialogVisible(val) {
            if(val) {
                this.itemStr = "";
                this.$emit("closeKeyWatch")
            }else {
                this.$emit("openKeyWatch")
            }
      },
      
    },
    methods: {
          /**
           * @description: 新增选项
           * @param {*}
           * @return {*}
           * @author: jinchuan.lee
           */          
          handleAdd() {
              if(!(this.itemStr.trim())) {
                    return this.$message.warning("新增不能为空！")
                }
              let data = this.itemStr.split(/[(\r\n)\r\n]+/);
              data = [...new Set(data)]; // 去重
              this.$emit('add',data)
          }
      }
}
</script>
<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-add-option.vue